var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"map-container"},[_c('div',{staticClass:"map-container__container"},[_c('iframe',{attrs:{"src":_vm.windyURL}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }